import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { ConfigProvider } from '../base/config';

import { Nav } from 'ionic-angular';

@Injectable()
export class BeneficiarioProvider {
  public resourceUrl: any =
    ConfigProvider.host + '/api/v1/front/saude/beneficiario';

  @ViewChild(Nav) nav: Nav;

  constructor(public http: HttpClient) {}

  perfil(params: any = {}, headers: HttpHeaders = null): Observable<any> {
    return this.http
      .get(this.resourceUrl + '/perfil', {
        params: params,
        headers: headers
      })
      .pipe(
        catchError((error) => {
          throw error;
        }),
        map((response: any) => {
          return response;
        })
      );
  }

  create(data, params: any = {}, headers: HttpHeaders = null) {
    return this.http
      .post(this.resourceUrl, data, {
        params: params,
        headers: headers
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  update(data, params: any = {}, headers: HttpHeaders = null) {
    return this.http
      .put(this.resourceUrl, data, {
        params: params,
        headers: headers
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  updateCompleto(data, params: any = {}, headers: HttpHeaders = null) {
    return this.http
      .put(`${this.resourceUrl}-completo`, data, {
        params: params,
        headers: headers
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  mudarImagem(data, params: any = {}, headers: HttpHeaders = null) {
    return this.http
      .post(this.resourceUrl + '/mudar-imagem', data, {
        params: params,
        headers: headers
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  dependentes(
    id: number,
    params: any = {},
    headers: HttpHeaders = null
  ): Observable<any> {
    return this.http
      .get(`${this.resourceUrl}/depedentes/${id}`, {
        params: params,
        headers: headers
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }
}



// WEBPACK FOOTER //
// ./src/providers/beneficiario/beneficiario.ts